import React from "react";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function NotificationDialog(props) {
  const { t } = useTranslation();

  // props value
  const { open, handleClose, header, messages } = props;

  return (
    <Dialog open={open} scroll="paper" TransitionComponent={Transition}>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" color="secondary" fontWeight="bold">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <List dense>
          {messages.map((message, idx) => (
            <ListItem key={idx} alignItems="flex-start" disablePadding>
              <ListItemIcon sx={{ minWidth: 36, marginTop: "4px" }}>
                <KeyboardArrowRightIcon />
              </ListItemIcon>
              <ListItemText primary={message} sx={{ whiteSpace: "pre-wrap" }} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Grid container sx={{ paddingX: 1.6 }} spacing={1}>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              fullWidth
              onClick={handleClose}
            >
              {t("Got it")}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
